import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton, Menu, MenuItem, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';

const Navbar = ({ role, logout }) => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:600px)');
    const [anchorEl, setAnchorEl] = useState(null);

    const handleLogout = () => {
        logout(); // Вызываем переданную функцию logout
        navigate('/'); // Перенаправляем на главную страницу
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleMenuClick = (path) => {
        navigate(path);
        handleMenuClose();
    };

    return (
        <AppBar position="static">
            <Toolbar>
                <Typography variant="h6" sx={{ flexGrow: 1 }}>
                    Система мониторинга сайтов Кировского района СПб
                </Typography>
                {isMobile ? (
                    <>
                        <IconButton color="inherit" onClick={handleMenuOpen}>
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                        >
                            {role === 'admin' && (
                                <>
                                    <MenuItem onClick={() => handleMenuClick('/')}>
                                        Главная
                                    </MenuItem>
                                    <MenuItem onClick={() => handleMenuClick('/dashboard')}>
                                        Результат проверки
                                    </MenuItem>
                                    <MenuItem onClick={() => handleMenuClick('/admin')}>
                                        Управление пользователями
                                    </MenuItem>
                                    <MenuItem onClick={() => handleMenuClick('/ou-links')}>
                                        Ссылки на сайты ОУ
                                    </MenuItem>
                                    <MenuItem onClick={handleLogout}>
                                        Выйти
                                    </MenuItem>

                                </>
                            )}
                            {role === 'user' && (
                                <>
                                <MenuItem onClick={() => handleMenuClick('/')}>
                                    Главная
                                </MenuItem>
                                <MenuItem onClick={() => handleMenuClick('/dashboard')}>
                            Результат проверки
                        </MenuItem>
                                <MenuItem onClick={handleLogout}>
                                    Выйти
                                </MenuItem>
                                </>
                            )}
                            {!role && (
                                <>
                                    <MenuItem onClick={() => handleMenuClick('/')}>
                                        Главная
                                    </MenuItem>
                                    <MenuItem onClick={() => handleMenuClick('/login')}>
                                        Войти
                                    </MenuItem>
                                </>
                            )}

                        </Menu>
                    </>
                ) : (
                    <>
                        {role === 'admin' && (
                            <>
                                <Button color="inherit" onClick={() => navigate('/')}>
                                    Главная
                                </Button>
                                <Button color="inherit" onClick={() => navigate('/dashboard')}>
                                    Результат проверки
                                </Button>

                                <Button color="inherit" onClick={() => navigate('/zapros')}>
                                    Запрос данных
                                </Button>
                                <Button color="inherit" onClick={() => navigate('/admin')}>
                                    Управление пользователями
                                </Button>
                                <Button color="inherit" onClick={() => navigate('/ou-links')}>
                                    Ссылки на сайты ОУ
                                </Button>
                                <Button color="inherit" onClick={handleLogout}>
                                    Выйти
                                </Button>

                            </>
                        )}
                        {role === 'user' && (
                            <>
                            <Button color="inherit" onClick={() => navigate('/')}>
                                Главная
                            </Button>
                                <Button color="inherit" onClick={() => navigate('/dashboard')}>
                                    Результат проверки
                                </Button>
                            <Button color="inherit" onClick={handleLogout}>
                                Выйти
                            </Button>
                            </>
                        )}
                        {!role && (
                            <>
                            <Button color="inherit" onClick={() => navigate('/')}>
                                Главная
                            </Button>
                            <Button color="inherit" onClick={() => navigate('/login')}>
                                Войти
                            </Button>
                            </>
                        )}
                    </>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;